/**
 * AUTO-GENERATED — DO NOT EDIT.
 * Source: sdk.manifest.yml + openapi.json.
 * Regenerate with: pnpm gen
 */


import { type QueryFunctionContext } from '@tanstack/react-query';

import { recordSnapshotLastSeq } from '../../nats/snapshot-seq-store.js';

import { fetchWithHttpTelemetry } from '../../transport/http-request.js';

import { throwHttpError } from '../../core/http-error.js';

import type { GetPublicPartnerCreatorRow } from '../openapi-types.gen.js';

import type { EntityKeyFactory, HookSpec } from '../../types/HookSpec.js';
import type { JsonSerialisableArgs } from '../../types/JsonSerialisableArgs.js';


// ─── useGetPublicPartnerCreator ────────────────────────────────────────────────────────────

export interface useGetPublicPartnerCreatorArgs { readonly id: string; }


async function _useGetPublicPartnerCreatorQueryFn(
  args: useGetPublicPartnerCreatorArgs,
  ctx: QueryFunctionContext,
): Promise<GetPublicPartnerCreatorRow | null> {
  if (args.id === undefined || args.id === null || args.id === '') return null;
  const url = `/v1/creators/${args.id}`;
  const params = new URLSearchParams();
  // Fixed response DTO — no caller-provided field projection.
  const sep = url.includes('?') ? '&' : '?';
  const full = params.size > 0 ? `${url}${sep}${params.toString()}` : url;
  const res = await fetchWithHttpTelemetry({
    operationName: 'useGetPublicPartnerCreator',
    routeTemplate: '/v1/creators/{id}',
    requestKind: 'query',
    method: 'GET',
    url: full,
    signal: ctx.signal,
    init: {
      method: 'GET',
      credentials: 'include',
      headers: { Accept: 'application/json' },
      ...(ctx.signal !== undefined ? { signal: ctx.signal } : {}),
    },
  });
  // A signed-out / session-expired caller gets 401 — that is a normal
  // "anonymous" state. A 403 retains its canonical error envelope.
  if (res.status === 401) return null;
  if (!res.ok) await throwHttpError('GET', full, res);
  const json = (await res.json()) as unknown;
  recordSnapshotLastSeq(ctx.queryKey, json);
  const data =
    json !== null && typeof json === 'object' && 'data' in json
      ? (json as { data: unknown }).data
      : json;
  return data as GetPublicPartnerCreatorRow;
}


const _useGetPublicPartnerCreatorFactory = Object.assign(
  (args: useGetPublicPartnerCreatorArgs) => ({
    queryKey: ['creators', 'detail', args.id] as readonly unknown[],
    queryFn: (ctx: QueryFunctionContext) => _useGetPublicPartnerCreatorQueryFn(args, ctx),
    staleTime: 1,
    // structuralSharing kept ON (TanStack default). The codegen-emitted
    // applyEvent already preserves row references for unchanged rows;
    // structural sharing on top lets per-card `select` selectors
    // short-circuit when their row hasn't changed, avoiding cascade
    // re-renders of every list child on each patch.
    meta: {
      realtime: false,
      pollingManaged: true,
      specName: 'useGetPublicPartnerCreator',
      viewerSensitive: false,
      persist: false,
    } as const,
  }),
  {
    __brand: 'EntityKeyFactory' as const,
    prefix: (id: string) => ['creators', 'detail', id] as readonly unknown[],
  },
) as unknown as EntityKeyFactory<useGetPublicPartnerCreatorArgs, GetPublicPartnerCreatorRow>;


export const useGetPublicPartnerCreatorSpec = {
  __brand: 'HookSpec' as const,
  path: '/v1/creators/{id}',
  method: 'GET' as const,
  kind: 'detail' as const,
  mounting: { kind: 'singleton' as const, allowsPerEntity: true },
  entityKeys: { detail: _useGetPublicPartnerCreatorFactory },
  parseInput: (raw: unknown): useGetPublicPartnerCreatorArgs => raw as useGetPublicPartnerCreatorArgs,
  parseResponse: (raw: unknown): GetPublicPartnerCreatorRow => raw as GetPublicPartnerCreatorRow,
  specName: 'useGetPublicPartnerCreator' as const,
  polling: { hasNats: false } as const,
  viewerSensitive: false as const,
  nonpersistent: true as const,
} as unknown as HookSpec<JsonSerialisableArgs, GetPublicPartnerCreatorRow>;
